/* eslint-disable @typescript-eslint/no-explicit-any */
import { ValidatorForm } from "react-material-ui-form-validator";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import { useEffect, useRef, useState } from "react";
import { Vocabulary } from "../../Utils/Vocabulary";
import { AlertModel } from "../../Utils/Models";
import OneAlert from "./OneAlert";

type AlertProps = {
  editAlert: AlertModel | null;
  open: boolean;
  propertyOptions: string[];
  ruleOptions: { label: string; value: string }[];
  addOrUpdateAlert: (alert: AlertModel) => void;
  onClose: () => void;
};

export default function AddNewAlert(props: AlertProps) {
  const {
    editAlert,
    open,
    propertyOptions,
    ruleOptions,
    addOrUpdateAlert,
    onClose,
  } = props;
  const [pressOnSubmit, setPressOnSubmit] = useState(false);
  const [alert, setAlert] = useState<AlertModel>(new AlertModel());

  const ref: any = useRef();

  /**
   *
   */
  useEffect(() => {
    if (editAlert) {
      setAlert(editAlert);
    } else {
      setAlert(new AlertModel());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editAlert]);

  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  return (
    <ValidatorForm ref={ref} onSubmit={() => addOrUpdateAlert(alert)}>
      <AddOrUpdateModel
        open={open}
        title={Vocabulary.alert}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        <OneAlert
          alert={alert}
          propertyOptions={propertyOptions}
          ruleOptions={ruleOptions}
          onChange={(alert: AlertModel) => {
            setAlert(alert);
          }}
        />
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
